import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 25px;
`;

type Props = {
  children?: React.ReactNode;
  maxWidth?: string;
  topMargin?: boolean;
  flex?: number;
};

function ContentCenterer({
  children,
  maxWidth = '1200px',
  topMargin,
  flex = 1,
}: Props) {
  return (
    <Container
      style={{
        maxWidth: maxWidth,
        marginTop: topMargin ? 70 : undefined,
        flex: flex,
      }}
    >
      {children}
    </Container>
  );
}

export default ContentCenterer;
